/**
 * Device Fingerprinting Utility
 * Generates a unique device fingerprint for session binding
 */

// Generate or retrieve a persistent device UUID
const getOrCreateDeviceUUID = () => {
  let deviceUUID = localStorage.getItem('device_uuid');
  if (!deviceUUID) {
    // Generate a new UUID
    deviceUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    localStorage.setItem('device_uuid', deviceUUID);
  }
  return deviceUUID;
};

// Get screen resolution
const getScreenResolution = () => {
  return `${window.screen.width}x${window.screen.height}`;
};

// Get timezone
const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Get user agent
const getUserAgent = () => {
  return navigator.userAgent;
};

// Generate device fingerprint object
export const getDeviceFingerprint = async () => {
  const fingerprint = {
    user_agent: getUserAgent(),
    screen_resolution: getScreenResolution(),
    timezone: getTimezone(),
    device_uuid: getOrCreateDeviceUUID()
  };

  return fingerprint;
};

// Check if current device matches stored session
export const validateDeviceSession = async (storedFingerprint) => {
  const currentFingerprint = await getDeviceFingerprint();
  
  // Compare key attributes
  return (
    currentFingerprint.device_uuid === storedFingerprint.device_uuid &&
    currentFingerprint.user_agent === storedFingerprint.user_agent
  );
};

export default getDeviceFingerprint;
